import React, { type PropsWithChildren, memo } from "react";
import CheckboxVariant, { type CheckboxVariants } from "./Checkbox.styles";
import { SrOnly } from "../utils/Accessibility.styles";

export type CheckboxVariantsType = keyof typeof CheckboxVariants;

export type CheckboxType = {
    checked: boolean;
    variant: CheckboxVariantsType;
    id: string;
    title?: string;
    disabled?: boolean;
    readOnly?: boolean;
    onClick?: () => void;
    onChange?: () => void;
};

const Checkbox: React.FC<PropsWithChildren<CheckboxType>> = (props) => {
    const { checked, variant, id, title, disabled, onClick, onChange, children, readOnly } = props;
    return (
        <CheckboxVariant variant={variant}>
            <input
                id={id}
                type="checkbox"
                title={title}
                disabled={disabled}
                checked={checked}
                onChange={onChange}
                onClick={onClick}
                readOnly={readOnly}
            />
            <label htmlFor={id}>
                {children}
                {children === null && <SrOnly data-testid="sr-only">{title}</SrOnly>}
            </label>
        </CheckboxVariant>
    );
};

export default memo(Checkbox);
